import { render } from "./ProgressTaskTable.vue?vue&type=template&id=58c6198a&scoped=true"
import script from "./ProgressTaskTable.vue?vue&type=script&lang=js"
export * from "./ProgressTaskTable.vue?vue&type=script&lang=js"

import "./ProgressTaskTable.vue?vue&type=style&index=0&id=58c6198a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c6198a"]])

export default __exports__